import { useCallback, useRef, useState } from 'react'

/**
 * For menu items that open an autofocused field. The menu restores focus to its
 * trigger on the way out, which lands on the field as a blur — so the action is
 * held until the menu has finished closing. Spread `menuProps` onto the Menu.
 */
export const useRunAfterMenuClose = () => {
  const [closeMenuCount, setCloseMenuCount] = useState(0)
  const pendingAction = useRef<(() => void) | null>(null)

  const closeMenu = useCallback(() => setCloseMenuCount((prev) => prev + 1), [])

  const runAfterClose = useCallback(
    (action: () => void) => {
      pendingAction.current = action
      closeMenu()
    },
    [closeMenu],
  )

  const onExited = useCallback(() => {
    const action = pendingAction.current
    pendingAction.current = null
    action?.()
  }, [])

  return { closeMenu, runAfterClose, menuProps: { closeMenuCount, onExited } }
}
